module.exports = function scmpCompare (a, b) {
  var len = a.length;
  var result = 0;
  for (var i = 0; i < len; ++i) {
    result |= a[i] ^ b[i];
  }
  return result === 0;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/scmp/lib/scmpCompare.js
// module id = Ieu0
// module chunks = 0